import Axios from "@/plugins/Axios";
// import store from "@/store";
import GestaoDeAula from "@/Models/GestaoDeAula";
import Aula from "@/Models/Aula";

export class GestoesDeAulasService {
  async syncAll(pageNumber, query) {
    const response = await Axios().get(`gestoes-de-aulas?page=${pageNumber}&query=${query}`);

    // store.commit("GestoesDeAulas/setGestoesDeAulas", gestoesDeAulas);
    return response.data;
  }

  async listarAulasGestao(gestaoDeAulaId) {
    const response = await Axios().post("gestoes-de-aulas/listar-aulas-gestao", {
      gestao_id: gestaoDeAulaId,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async listarAulasIntervaloData(gestaoDeAulaId, intervalo) {
    const response = await Axios().post("gestoes-de-aulas/listar-aulas-intervalo-datas", {
      gestao_id: gestaoDeAulaId,
      intervalo,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async listarAulasDaGestaoPaginate(gestaoDeAulaId, pageNumber = 0, query = "", itemsPerPage) {
    const response = await Axios().post(
      `gestoes-de-aulas/listar-aulas-da-gestao-paginate?page=${pageNumber}&query=${query},&itemsPerPage=${itemsPerPage}`,
      {
        gestao_id: gestaoDeAulaId,
      }
    );
    const aulas = response.data.aulas.data.map((aulas) => new Aula(aulas));
    const data = response.data.aulas;
    const payload = response.data;
    return { aulas, payload, data };
  }

  async listarAulasGestaoInfantil(gestaoDeAulaId) {
    const response = await Axios().post("gestoes-de-aulas/listar-aulas-gestao-infantil", {
      gestao_id: gestaoDeAulaId,
    });
    const aulas = response.data.gestaoDeAula.aulas.map((aulas) => new Aula(aulas));
    const payload = response.data;
    return { aulas, payload };
  }

  async visualizar(gestaoDeAula) {
    const response = await Axios().get(`gestoes-de-aulas/${gestaoDeAula}/visualizar`);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async visualizarTurma(gestaoDeAula) {
    const response = await Axios().get(`gestoes-de-aulas/${gestaoDeAula}/visualizar/turma`);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async visualizarTurmaGestao(gestaoDeAulaId) {
    const response = await Axios().get(`gestoes-de-aulas/visualizar-turma/${gestaoDeAulaId}`);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async gestaoGeralId(gestaoDeAulaId) {
    const filtro = true;
    const response = await Axios().get(`gestoes-de-aulas/${gestaoDeAulaId}/visualizar/${filtro}`);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async geral() {
    const response = await Axios().get(`gestoes-de-aulas/geral`);
    const gestoesDeAulasGeral = response.data.map(
      (gestaoDeAulas) => new GestaoDeAula(gestaoDeAulas)
    );
    // store.commit("GestoesDeAulas/setGestoesDeAulas", gestoesDeAulasGeral);

    return gestoesDeAulasGeral;
  }

  async geralPaginate(pageNumber, query) {
    const response = await Axios().get(`gestoes-de-aulas/geral?page=${pageNumber}&query=${query}`);

    return response.data;
  }

  async listarGestoesProfessor(gestao) {
    const response = await Axios().post(`gestoes-de-aulas/listar-gestoes-professor`, {
      gestao,
    });
    return response.data;
  }

  async listarGestaoDeAulasDaTurma(turma_id) {
    const response = await Axios().post(`gestoes-de-aulas/listar-gestoes-aulas-turma`, {
      turma_id,
    });
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async criar(relacoesList) {
    const response = await Axios().post("gestoes-de-aulas", relacoesList);
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async atualizar(gestaoDeAulas) {
    const response = await Axios().put(`gestoes-de-aulas/${gestaoDeAulas.id}`, gestaoDeAulas);
    const gestaoDeAulasAtualizada = response.data;
    // store.commit("GestoesDeAulas/atualizarGestaoDeAula", gestaoDeAulasAtualizada);
    return gestaoDeAulasAtualizada;
  }

  async deletarGestaoDeAula(gestaoDeAulas) {
    const response = await Axios().delete(`gestoes-de-aulas/${gestaoDeAulas.id}`);
    const gestaoDeAulasDeletada = response.data;
    // store.commit("GestoesDeAulas/deletarGestaoDeAula", gestaoDeAulas.id);
    return gestaoDeAulasDeletada;
  }

  async recuperarGestaoDeAula(gestaoDeAulas) {
    return this.atualizarGestaoDeAula({ ...gestaoDeAulas, deleted_at: null });
  }

  async historicoAulasLancadas(gestaoDeAulaId) {
    const response = await Axios().get(
      `gestoes-de-aulas/historico-aulas-lancadas/${gestaoDeAulaId}`
    );
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async historicoPlanosLancados(gestaoDeAulaId, etapa_id, disciplina_id) {
    const response = await Axios().get(
      `gestoes-de-aulas/historico-planos-lancados/${gestaoDeAulaId}/${etapa_id}/${disciplina_id}`
    );
    return response.data;
    // store.commit("GestoesDeAulas/adicionarGestaoDeAula", novaGestaoDeAula);
    // return novaGestaoDeAula;
  }

  async getContabilizadoDadosGestao(gestaoDeAulasId) {
    const response = await Axios().get(
      `gestoes-de-aulas/contabilizado-dados-gestao/${gestaoDeAulasId}`
    );
    return response.data;
  }

  async getProfessoresComPendencias(configuracao_id) {
    const response = await Axios().get(
      `gestoes-de-aulas/professores-com-pendencias/${configuracao_id}`
    );
    return response.data.franquiaComGestoes;
  }

  async getAllHorarios() {
    const response = await Axios().get("gestoes-de-aulas/horarios/all");
    return response.data;
  }

  async createPlanejamentoAulas(data) {
    const response = await Axios().post(`gestoes-de-aulas/criar-planejamento-aulas`, data);
    return response.data;
  }

  async listarPlanejamentoAulas() {
    const response = await Axios().get(`gestoes-de-aulas/listar-planejamento-aulas`);
    return response.data.planejamentoAulas;
  }

  async buscarPlanejamentoAula(planejamento_aula_id) {
    const response = await Axios().get(
      `gestoes-de-aulas/buscar-planejamento-aulas/${planejamento_aula_id}`
    );
    return response.data;
  }

  async registrarPresencaPlanejamentoAula(planejamento_aula_id, instrutor_id, presenca) {
    const response = await Axios().post(`gestoes-de-aulas/registrar-falta-planejamento-aulas`, {
      planejamento_aula_id,
      instrutor_id,
      presenca,
    });

    return response.data;
  }

  async justificarFaltaProfessorPlanejamento(
    planejamento_aula_id,
    { observacao = "", file = null, professor_id = null, justificativa_id = null }
  ) {
    const formData = new FormData();
    formData.append("observacao", observacao);
    if (file) {
      formData.append("file", file);
    }
    formData.append("instrutor_id", professor_id);
    formData.append("justificativa_id", justificativa_id);
    formData.append("planejamento_aula_id", planejamento_aula_id);

    console.log(formData);

    const response = await Axios().post(
      `gestoes-de-aulas/justificar-falta-planejamento-aulas`,
      formData
    );
    return response.data;
  }

  async baixarDocumentoJustificativaPlanejamento(planejamento_aula_id, instrutor_id) {
    const response = await Axios().get(
      `gestoes-de-aulas/baixar-documento-justificativa/${planejamento_aula_id}/${instrutor_id}`,
      { responseType: "blob" }
    );

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(response.data);
    link.download = ""; // deixa o backend decidir o nome
    link.click();
  }

  async deletarPlanejamentoAula(planejamento_aula_id) {
    const response = await Axios().delete(
      `gestoes-de-aulas/deletar-planejamento-aulas/${planejamento_aula_id}`
    );
    console.log(response.data);

    return response.data;
  }
}

export default new GestoesDeAulasService();
